var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplicitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5833 0.25H4.41667C2.125 0.25 0.25 2.125 0.25 4.41667V33.5833C0.25 35.875 2.125 37.75 4.41667 37.75H33.5833C35.875 37.75 37.75 35.875 37.75 33.5833V4.41667C37.75 2.125 35.875 0.25 33.5833 0.25ZM25.25 12.75H16.9167V16.9167H25.25V21.0833H16.9167V25.25H25.25V29.4167H12.75V8.58333H25.25V12.75Z",
    fill: "rgb(112,112,112)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplicitIcon);
export default __webpack_public_path__ + "static/media/explicit_icon.68d33231f655a32f0c813e8388134e0c.svg";
export { ForwardRef as ReactComponent };